import React, { useContext, useEffect, useState } from "react";
import "./Login.css";
import Cowsmall from "../../imgs/cowsmall.gif";
import Grass from "../../imgs/grass.png";
import Dairylogo from "../../imgs/dairylogo.png";
import bcrypt from "bcryptjs";
import axios from "axios";
import Phone from "../../imgs/next.png";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Globalcontext from "../../Context/Globalcontext";
import { waitFor } from "@testing-library/react";
import { useTranslation } from "react-i18next";

const Login = (props) => {
  const { t } = useTranslation();

  const SUPPORT_PHONE = "+91 800-788-9200";

  const [input, setInput] = useState({ contact: "", password: "" });
  const navigate = useNavigate();
  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);
  const [DataSource, setDataSource] = useState([]);
  const [Wait, setWait] = useState(false);
  const { custlist, setCustlist } = useContext(Globalcontext);
  let parent = "";

  const handleChange = (event) => {
    const name = event.target.name;
    const valuecurrent = event.target.value;
    setInput((value) => ({ ...value, [name]: valuecurrent }));
  };

  async function getmykendra() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    props.setProgress(30);
    setTimeout(() => props.setProgress(50), 200);

    axios
      .post("https://excellentdairy.com/dairy/php/cust/getmykendra2.php", {
        mainuser: input.contact,
        mainuser2: mainuser2,
      })
      .then(function sample(response) {
        if (response.data) {
          if (response.data.length > 0) {
            setDataSource(response.data);
          } else {
            localStorage.setItem("status", "true");
            localStorage.setItem("contact", input.contact);
            localStorage.setItem("kendra", "Not available");
            localStorage.setItem("city", "Not available");
            localStorage.setItem("lastbilldate", "Not available");
            navigate("/dashboard");
            notify(t("Login.toast.welcome"));
            setWait(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setWait(false);
      });
  }

  useEffect(() => {
    if (DataSource.length > 0) {
      props.setProgress(50);
      setTimeout(() => props.setProgress(100), 200);

      DataSource.map((user) => (
        localStorage.setItem("kendra", user.name),
        localStorage.setItem("city", user.city),
        localStorage.setItem("kmobno", user.mobno),
        localStorage.setItem("contact", user.mobno),
        localStorage.setItem("ksr", user.sr),
        localStorage.setItem("lastbilldate", user.maxdate)
      ));

      getcustomers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [DataSource]);

  async function getcustomers() {
    // notify(input.contact); // keep commented if you don't want toast for contact
    var mainuser2 = jsEncode.encode("mamapr", 125);
    props.setProgress(30);
    setTimeout(() => props.setProgress(50), 200);

    axios
      .post("https://excellentdairy.com/dairy/php/cust/getaccoounttemp.php", {
        mainuser: input.contact,
        mainuser2: mainuser2,
      })
      .then(function sample(response) {
        if (response.data.length > 0) {
          localStorage.setItem("custlist", JSON.stringify(response.data));
          setTimeout(() => props.setProgress(100), 200);
        } else {
          setInput({ kno: 1 });
        }
        getratetablemh();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getratetablemh() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    props.setProgress(30);
    setTimeout(() => props.setProgress(50), 200);

    let typetemp = "Buffalo";
    let typeid = "1";

    try {
      const response = await axios.post("https://excellentdairy.com/dairy/php/cust/getkratevibhag.php", {
        vibhag: "Ratechart-1",
        typeid: typeid,
        type: typetemp,
        mainuser: input.contact,
        mainuser2: mainuser2,
      });

      if (response.data.length > 0) {
        localStorage.setItem("mhrates", JSON.stringify(response.data));
      }

      getratetablegay();
    } catch (error) {
      console.log(error);
    }
  }

  async function getratetablegay() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    props.setProgress(30);
    setTimeout(() => props.setProgress(50), 200);

    let typetemp = "Cow";
    let typeid = "2";

    try {
      const response = await axios.post("https://excellentdairy.com/dairy/php/cust/getkratevibhag.php", {
        vibhag: "Ratechart-1",
        typeid: typeid,
        type: typetemp,
        mainuser: input.contact,
        mainuser2: mainuser2,
      });

      if (response.data.length > 0) {
        localStorage.setItem("gayrates", JSON.stringify(response.data));
      }
      gettreport();
    } catch (error) {
      console.log(error);
    }
  }

  async function gettreport() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    props.setProgress(30);
    setTimeout(() => props.setProgress(50), 200);

    axios
      .post("https://excellentdairy.com/dairy/php/cust/gettreport.php", {
        mainuser: input.contact,
        mainuser2: mainuser2,
      })
      .then(function sample(response) {
        if (response.data && response.data.length > 0) {
          localStorage.setItem("treport", JSON.stringify(response.data));
        }
        getratetablemh9();
      })
      .catch((err) => console.log(err));
  }

  async function getratetablemh9() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    props.setProgress(30);
    setTimeout(() => props.setProgress(50), 200);

    let typetemp = "Buffalo";
    let typeid = "1";

    try {
      const response = await axios.post("https://excellentdairy.com/dairy/php/cust/getkratevibhag.php", {
        vibhag: "Ratechart-9 (M)",
        typeid: typeid,
        type: typetemp,
        mainuser: input.contact,
        mainuser2: mainuser2,
      });

      if (response.data.length > 0) {
        localStorage.setItem("mhrates9", JSON.stringify(response.data));
      }

      getratetablegay9();
    } catch (error) {
      console.log(error);
    }
  }

  async function getratetablegay9() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    props.setProgress(30);
    setTimeout(() => props.setProgress(50), 200);

    let typetemp = "Cow";
    let typeid = "2";

    try {
      const response = await axios.post("https://excellentdairy.com/dairy/php/cust/getkratevibhag.php", {
        vibhag: "Ratechart-9 (M)",
        typeid: typeid,
        type: typetemp,
        mainuser: input.contact,
        mainuser2: mainuser2,
      });

      if (response.data.length > 0) {
        localStorage.setItem("gayrates9", JSON.stringify(response.data));
      }

      getauditlist();
    } catch (error) {
      console.log(error);
    }
  }

  async function getauditlist() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    setTimeout(() => props.setProgress(70), 200);

    axios
      .post("https://excellentdairy.com/dairy/php/cust/getaudit.php", {
        mainuser: localStorage.getItem("contact"),
        mainuser2: mainuser2,
      })
      .then(function sample(response) {
        if (response.data.length > 0) {
          localStorage.setItem("auditlist", JSON.stringify(response.data));
        }
        setTimeout(() => props.setProgress(100), 200);

        getratetablemhsangh();
      })
      .catch((err) => console.log(err));
  }

  async function getratetablemhsangh() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    props.setProgress(30);
    setTimeout(() => props.setProgress(50), 200);

    let typetemp = "Buffalo";
    let typeid = "1";

    try {
      const response = await axios.post("https://excellentdairy.com/dairy/php/cust/getkratesangh.php", {
        vibhag: "Ratechart-1",
        typeid: typeid,
        type: typetemp,
        mainuser: input.contact,
        mainuser2: mainuser2,
      });

      if (response.data.length > 0) {
        localStorage.setItem("mhratesangh", JSON.stringify(response.data));
      }

      getratetablegaysangh();
    } catch (error) {
      console.log(error);
    }
  }

  async function getratetablegaysangh() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    props.setProgress(30);
    setTimeout(() => props.setProgress(50), 200);

    let typetemp = "Cow";
    let typeid = "2";

    try {
      const response = await axios.post("https://excellentdairy.com/dairy/php/cust/getkratesangh.php", {
        vibhag: "Ratechart-1",
        typeid: typeid,
        type: typetemp,
        mainuser: input.contact,
        mainuser2: mainuser2,
      });

      if (response.data.length > 0) {
        localStorage.setItem("gayratesangh", JSON.stringify(response.data));
      }

      localStorage.setItem("status", "true");
      navigate("/dashboard");
      notify(t("Login.toast.welcome"));
    } catch (error) {
      console.log(error);
    }
  }

  const handlelogin = (event) => {
    event.preventDefault();
    setWait(true);

    var passsend = jsEncode.encode(input.password, 125);

    let rawData = {
      contact: input.contact,
      password: passsend,
    };
    rawData = JSON.stringify(rawData);

    let formData = new FormData();
    formData.append("data", rawData);

    axios
      .post("https://excellentdairy.com/dairy/php/cust/login.php", formData, {
        "Content-Type": "multipart/form-data",
      })
      .then(function sample(response) {
        if (response.data === "Invalid Password!!") {
          props.setProgress(50);
          notifyerror(t("Login.toast.invalidCredentials"));
          localStorage.setItem("status", "true");

          setTimeout(() => props.setProgress(100), 200);
          setTimeout(() => props.setProgress(0), 200);

          setWait(false);
        } else if (String(response.data || "").trim() === "Welcome to Account!") {
          props.setIsLoggedIn(true);
          getparent();
        }

        props.setProgress(30);
        setTimeout(() => props.setProgress(100), 200);
      })
      .catch((err) => {
        console.log(err);
        setWait(false);
      });
  };

  async function getparent() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    props.setProgress(30);
    setTimeout(() => props.setProgress(50), 200);

    axios
      .post("https://excellentdairy.com/dairy/php/cust/getparent.php", {
        mainuser: input.contact,
        mainuser2: mainuser2,
      })
      .then(function sample(response) {
        if (response.data && response.data.length > 0) {
          response.data.map((user) => (parent = user.activekendra));
          setInput((value) => ({ ...value, contact: parent }));
        }
        getmyinfo();
      })
      .catch((err) => console.log(err));
  }

  async function getmyinfo() {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    props.setProgress(30);
    setTimeout(() => props.setProgress(50), 200);

    axios
      .post("https://excellentdairy.com/dairy/php/cust/getmyinfo.php", {
        mainuser: input.contact,
        mainuser2: mainuser2,
      })
      .then(function sample(response) {
        if (response.data && response.data.length > 0) {
          response.data.map((user) => (
            localStorage.setItem("name", user.dairy),
            localStorage.setItem("city", user.city),
            localStorage.setItem("tal", user.tal),
            localStorage.setItem("dist", user.dist),
            localStorage.setItem("username", user.username),
            localStorage.setItem("mobile", user.mobile),
            localStorage.setItem("status", user.status),
            localStorage.setItem("vdate", user.vdate),
            localStorage.setItem("bill10type", user.billtype),
            localStorage.setItem("khdate", user.khdate),
            localStorage.setItem("plant", user.plant),
            localStorage.setItem("parent", user.parent),
            localStorage.setItem("suchana", user.suchana),
            localStorage.setItem("thevper", user.thevper),
            localStorage.setItem("dur", user.dur),
            localStorage.setItem("digri", user.digri),
            localStorage.setItem("autosnf", user.autosnf),
            localStorage.setItem("itr1name", user.itr1name),
            localStorage.setItem("itr1type", user.itr1type),
            localStorage.setItem("itr1value", user.itr1value),
            localStorage.setItem("itr2name", user.itr2name),
            localStorage.setItem("itr2type", user.itr2type),
            localStorage.setItem("itr2value", user.itr2value),
            localStorage.setItem("itr3name", user.itr3name),
            localStorage.setItem("itr3type", user.itr3type),
            localStorage.setItem("itr3value", user.itr3value),
            localStorage.setItem("itr4name", user.itr4name),
            localStorage.setItem("itr4type", user.itr4type),
            localStorage.setItem("itr4value", user.itr4value),
            localStorage.setItem("itr5name", user.itr5name),
            localStorage.setItem("itr5type", user.itr5type),
            localStorage.setItem("itr5value", user.itr5value),
            localStorage.setItem("itr6name", user.itr6name),
            localStorage.setItem("itr6type", user.itr6type),
            localStorage.setItem("itr6value", user.itr6value),
            localStorage.setItem("itrname", user.itrname),
            localStorage.setItem("itrtype", user.itrtype),
            localStorage.setItem("itrvalue", user.itrvalue),
            localStorage.setItem("retan", user.retan),
            localStorage.setItem("medi", user.medi),
            localStorage.setItem("karj", user.karj),
            localStorage.setItem("bhishi", user.bhishi),
            localStorage.setItem("sanghk", user.sanghk),
            localStorage.setItem("adminpass", user.pass),
            localStorage.setItem("enname", user.enname),
            localStorage.setItem("lpoints", user.lpoints),
            localStorage.setItem("round", user.round),
            localStorage.setItem("sankprint", user.sankprint),
            localStorage.setItem("custbill", user.custbill),
            localStorage.setItem("avg", user.avg),
            localStorage.setItem("weightcomm", user.weightcomm),
            localStorage.setItem("weightbrate", user.weightbrate),
            localStorage.setItem("fatcomm", user.fatcomm),
            localStorage.setItem("fatbrate", user.fatbrate),
            localStorage.setItem("purdate", user.purdate),
            localStorage.setItem("itrmainname", user.itrmainname),
            localStorage.setItem("sanghkname", user.sanghkname),
            localStorage.setItem("bankreport", user.bankreport),
            localStorage.setItem("autocutting", user.autocutting),
            localStorage.setItem("audit", user.audit),
            (parent = user.parent === "self" ? input.contact : user.parent)
          ));
        }

        if (localStorage.getItem("status") === "Expired") {
          // notify(
          //   t("Login.toast.expired", { phone: SUPPORT_PHONE })
          // );
          localStorage.setItem("status", "");
          localStorage.setItem("vdate", "");
          setWait(false);
        } else if (localStorage.getItem("status") === "Activated") {
          localStorage.setItem("contactplant", input.contact);
          getmykendra();
        }
      })
      .catch((err) => console.log(err));
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    },
  };

  return (
    <div className="mainbox">
      <section className="vh-100">
        <div className="container py-5 h-100">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col-12 col-md-8 col-lg-6 col-xl-5">
              <div className="firstrowlogin">
                <div className="cowimg">
                  <img className="leftimg" src={Cowsmall} alt="" />
                  <img className="grass" src={Grass} alt="" />
                </div>
                <div className="secondlogo">
                  <img className="logologin" src={Dairylogo} alt="" />
                  <span className="verfont">Ver 1.0.7</span>
                </div>
              </div>

              <div className="card shadow-2-strong">
                <div className="card-body p-5 text-center">
                  <span className="kharedi">
                    {t("Login.ui.purchaseContact", { phone: SUPPORT_PHONE })}
                  </span>

                  <h3 className="heading">{t("Login.ui.title")}</h3>

                  <div className="form-outline mb-4">
                    <label className="form-label" htmlFor="contact">
                      {t("Login.ui.mobile")}
                    </label>
                    <input
                      type="text"
                      onChange={handleChange}
                      id="contact"
                      name="contact"
                      className="form-control form-control-lg"
                      value={input.contact}
                    />
                  </div>

                  <div className="form-outline mb-4">
                    <label className="password" htmlFor="password">
                      {t("Login.ui.password")}
                    </label>
                    <input
                      type="password"
                      onChange={handleChange}
                      id="password"
                      name="password"
                      className="form-control form-control-lg"
                      value={input.password}
                    />
                  </div>
                  {Wait ? (
                    <button
                      onClick={handlelogin}
                      className="btn btn-primary btn-lg btn-block"
                      type="submit"
                    >
                      {t("Login.ui.loading")}
                    </button>
                  ) : (
                    <button
                      onClick={handlelogin}
                      className="btn btn-primary btn-lg btn-block"
                      type="submit"
                    >
                      {t("Login.ui.loginBtn")}
                    </button>
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </div>
  );
};

export default Login;
